import {
  arrayOf as arrayType,
  params,
  shape as shapeType,
  string as stringType,
  bool as boolType,
  extend,
} from '@thd-nucleus/data-sources';

const pod = shapeType({
  title: stringType(),
  description: stringType(),
  imageUrl: stringType(),
  link: stringType(),
  isProContent: boolType(),
  recordType: stringType(),
});

const contentPod = shapeType({
  title: stringType(),
  description: stringType(),
  imageUrl: stringType(),
  link: stringType(),
  type: stringType(),
  podTitle: stringType(),
  recordType: stringType()
});

export const contentServicesModel = {
  getContent: params({ query: stringType() }).arrayOf(contentPod)
};

const universalSearchWithPods = shapeType({
  pods: arrayType(pod),
  info: shapeType({
    title: stringType(),
  })
});

export const dataModel = extend({
  searchModel: params({ keyword: stringType(), navParam: stringType(), storeId: stringType() }).shape({
    orangeGraph: shapeType({
      universalSearchArray: arrayType(universalSearchWithPods),
      productTypes: arrayType(stringType())
    })
  })
}, contentServicesModel);
